// Module-level cache for firm-wide settings (formerly localStorage blobs).
// FirmSettingsProvider populates this on app boot; sync helpers read from
// it; mutations PATCH the API key-by-key and update the cache optimistically.

let _cache = {};
const _listeners = new Set();

export function setFirmSettingsCache(s) {
  _cache = s && typeof s === 'object' ? s : {};
  for (const fn of _listeners) {
    try { fn(_cache); } catch {}
  }
}

export function patchFirmSettingsCache(keys) {
  _cache = { ..._cache, ...keys };
  for (const fn of _listeners) {
    try { fn(_cache); } catch {}
  }
}

export function getFirmSettingsCache() {
  return _cache;
}

export function subscribeFirmSettings(fn) {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
}
